import { render, staticRenderFns } from "./TabRestrictions.vue?vue&type=template&id=38855b36&scoped=true"
import script from "./TabRestrictions.vue?vue&type=script&lang=js"
export * from "./TabRestrictions.vue?vue&type=script&lang=js"
import style0 from "./TabRestrictions.vue?vue&type=style&index=0&id=38855b36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38855b36",
  null
  
)

export default component.exports